import { FC } from "react";

import { TopHeaderCalendar } from "@ryde/controls";
import { LayoutCrudRoutes, PageClientSideFilters } from "@ryde/layout";
import { usePageContext } from "@ryde/redux";

export const FeedbacksPageContent: FC = () => {
  const { entity } = usePageContext();

  return (
    <>
      <PageClientSideFilters
        topWidgetComponent={<TopHeaderCalendar entity={entity} />}
      />
      <LayoutCrudRoutes />
    </>
  );
};
